module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "editor.worker.30ee016890ae2cd7624c.js");
}
